import { useLingui } from "@lingui/react/macro";
import type { MessageBlock } from "@rakazo/contracts";
import { CONVERSATION_UNAVAILABLE, conversationReferencePaths } from "@rakazo/contracts";
import { isServerUnreachable } from "@rakazo/core";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { rpc, selectSpace } from "../lib/rpc";

export function ConversationReferenceCard({
  block,
}: {
  block: Extract<MessageBlock, { kind: "conversation" }>;
}) {
  const { t } = useLingui();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  async function open() {
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      const reference = await rpc.threads.reference({
        botId: block.botId,
        sourceSpaceId: block.spaceId,
        threadId: block.threadId,
        ...(block.messageId ? { messageId: block.messageId } : {}),
      });
      if (!selectSpace(reference.sourceSpaceId)) throw new Error(CONVERSATION_UNAVAILABLE);
      navigate(conversationReferencePaths(reference).webPath);
    } catch (cause) {
      setError(
        isServerUnreachable(cause) ? t`Could not reach the server` : t`Conversation unavailable`,
      );
    } finally {
      setBusy(false);
    }
  }
  return (
    <div className="flex max-w-full flex-col items-end gap-1">
      <button
        type="button"
        disabled={busy}
        onClick={() => void open()}
        className="max-w-full truncate rounded-2xl border border-border bg-muted px-4 py-2 text-left text-sm text-foreground"
      >
        {t`Conversation reference`}
      </button>
      {error ? (
        <p role="alert" className="text-xs text-destructive">
          {error}
        </p>
      ) : null}
    </div>
  );
}
